import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppBrowserModule, preserveAgrSessionSnapshot, setupRuntimeConfig } from './app/app.browser.module';
import { environment } from './environments/environment';

if (environment.PRODUCTION) {
  enableProdMode();
}
preserveAgrSessionSnapshot();
setupRuntimeConfig.then(() => {
  platformBrowser()
    .bootstrapModule(AppBrowserModule, { applicationProviders: [provideZoneChangeDetection()] })
    .catch((err) => console.error(err));
});
